import styled from 'styled-components';

import { clearButtonStyles } from 'uiVe/styles/mixins';

export const Button = styled.button`
  ${clearButtonStyles}
`;
